import { useState, useEffect } from 'react';
import Logo from "../../assets/logo.png";
import { MDBInput } from 'mdb-react-ui-kit';
import { ValidaId, mascaraCNPJ, mascaraCPF, mascaraDocCO, validaCpf, validaCnpj } from '../../util/ValidaId';
import LpData from '../../util/ValidDocType'

export const AppletTermos = (props) => {
    const [numberDoc, setNumberDoc] = useState("");
    const numberDoc1=sessionStorage.getItem("documento_cliente")?sessionStorage.getItem("documento_cliente"):null;
    const [labelInput, setLabelInput] = useState("");


    //A cada valor digitado no campo de número de documento essa função é chamada
    function handleChange(event) {
        const { value } = event.target;
        //Salva o valor do documento sem pontuação para ser validado
        let valorLimpo;
        const country=props.orderFrom.toLowerCase()
        if(country==="br" || country==="co" || country==="ar"){
            valorLimpo = value.toString().replace(new RegExp("[^\\d]", 'g'), '');
        }else{
            valorLimpo=value.toString()
        }
        if (value !== "") {
            //Aqui é validado se é um documento válido e definido a mascara do campo de acordo com o tipo de documento
            switch (props.orderFrom.toLowerCase()) {
                case "br":
                    if (valorLimpo.length <= 11) {
                        setNumberDoc(mascaraCPF(valorLimpo));
                        props.changeDoc(validaCpf(valorLimpo));
                    } else if (valorLimpo.length <= 14) {
                        setNumberDoc(mascaraCNPJ(valorLimpo.substring(0, 18)));
                        //console.log(validaCnpj);
                        props.changeDoc(validaCnpj(valorLimpo));
                    } else {
                        setNumberDoc(value.substring(0, 18));
                    }
                    break;
                default:
                    setNumberDoc(valorLimpo);
                    props.changeDoc(ValidaId(valorLimpo, props.orderFrom));
                    break;
            }
        } else {
            setNumberDoc("");
        }
    }

    //Função para retornar o id do campo de documento dependendo do país
    function idFildDoc() {
        // console.log(props.orderFrom.toLowerCase());
        switch (props.orderFrom.toLowerCase()) {
            case "br":
                return "docFieldBR";
            case "co":
                return "docFielCO";
            case "ar":
                return "docFieldAR";
            case "ar":
                return "docFieldMX";
            default:
                return "genericFild";
        }
    }

    const handlePDFTerms = () => {
        switch (props.lang.nameLang) {
            case "pt-br":
                return "https://checkout.payeasy.tech/Terms_BR.pdf";
            case "en":
                return "https://checkout.payeasy.tech/Terms_EN.pdf";
            case "es":
                return "https://checkout.payeasy.tech/Terms_ES.pdf";
            default:
                return "https://checkout.payeasy.tech/Terms_BR.pdf";
        }
    }

    //Define o label do campo de acordo com o país da ordem
    useEffect(() => {
        if (props.orderFrom !== "") {
            setLabelInput(props.getStrLang(props.lang.nameLang, `insert_your`)+" "+ LpData[props.orderFrom.toLowerCase()].document_type);
        }
    }, [props]);

    useEffect(() => {
        if (numberDoc1) {           
            let value = numberDoc1;
            //Salva o valor do documento sem pontuação para ser validado
            let valorLimpo = value.toString().replace(new RegExp("[^\\d]", 'g'), '');
            if (value !== "") {
                //Aqui é validado se é um documento válido e definido a mascara do campo de acordo com o tipo de documento
                switch (props.orderFrom.toLowerCase()) {
                    case "br":
                        if (valorLimpo.length <= 11) {
                            setNumberDoc(mascaraCPF(valorLimpo));
                            props.changeDoc(validaCpf(valorLimpo));
                        } else if (valorLimpo.length <= 14) {
                            setNumberDoc(mascaraCNPJ(valorLimpo.substring(0, 18)));
                            //console.log(validaCnpj);
                            props.changeDoc(validaCnpj(valorLimpo));
                        } else {
                            setNumberDoc(value.substring(0, 18));
                        }
                        break;
                    case "co":
                        if (valorLimpo.length <= 10) {
                            setNumberDoc(mascaraDocCO(valorLimpo));
                            props.changeDoc(ValidaId(valorLimpo, props.orderFrom));
                        } else {
                            setNumberDoc(value.substring(0, 11));
                        }
                        break;
                    case "ar":
                        if (valorLimpo.length <= 11) {
                            setNumberDoc(mascaraDocCO(valorLimpo));
                            props.changeDoc(ValidaId(valorLimpo, props.orderFrom));
                        } else {
                            setNumberDoc(value.substring(0, 12));
                        }
                        break;
                    case "mx":
                        if (valorLimpo.length <= 17) {
                            setNumberDoc(valorLimpo);
                            props.changeDoc(ValidaId(valorLimpo, props.orderFrom));
                        } else {
                            setNumberDoc(value.substring(0, 18));
                        }
                        break;
                    default:
                        setNumberDoc(valorLimpo);
                        props.changeDoc(ValidaId(valorLimpo, props.orderFrom));
                        break;
                }
            } else {
                setNumberDoc("");
            }
        }

    }, [])
    console.log(props)
    return (
        <div className="tela_termos">
            {props.is_white_label && props.client_logo && <img src={props.client_logo} alt={"Logo"} style={{ marginTop: "5px", width: "30%" }} />}
            {props.client_logo ==="payeasy" && <img src={Logo} alt={"Logo"} style={{ marginTop: "5px", width: "30%" }} />}
            <div className="group_terms">
                <div className={numberDoc.length > 0 ? 'inputDoc' : 'inputDocVazio'}>
                    <MDBInput label={labelInput} id={idFildDoc()} name="docNumber" type='text' value={numberDoc1?numberDoc1:numberDoc} onChange={numberDoc1?"":handleChange} />
                </div>
                <div className="custom-control custom-checkbox">
                    <input className="form-check-input" type="checkbox" id="checkboxNoLabel" value="" aria-label="..." onChange={props.aceitetermos} />
                    <span>{props.getStrLang(props.lang.nameLang, "aceit_o") + " "}<a href={handlePDFTerms()} target="_blank" className="link-termos">{props.getStrLang(props.lang.nameLang, "termo_cd")}</a>{" " + props.getStrLang(props.lang.nameLang, "termo_op")}{<a href={sessionStorage.getItem("url")} target="_blank" className="link-termos">{props.clientName}</a>}.</span>
                </div>
                <button disabled={props.termos && props.doc ? false : true} data-lang-str={props.dataLang} color="primary" size='lg' onClick={props.mostrarInformacoesPgto} className="btn_term btn btn-primary"></button>
            </div>
        </div>
    )
}